import { Injectable } from '@angular/core';
import { fromEvent, map, merge, Observable, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {

  public isActive$: Observable<boolean>;

  constructor() {
    this.isActive$ = merge(
      fromEvent(document, 'visibilitychange').pipe(map(() => !document.hidden)),
      fromEvent(window, 'focus').pipe(map(() => true)),
      fromEvent(window, 'blur').pipe(map(() => false))
    ).pipe(
      // startWith zorgt dat we direct bij het laden weten waar we aan toe zijn
      startWith(document.hasFocus() && !document.hidden)
    );
  }
}
